import * as React from "react";
import { DifficultyLevelItem } from "./DifficultyLevelItem";
export var DifficultyLevelSelection = React.memo(function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, difficultyLevel = _a.difficultyLevel, difficultyLevelMax = _a.difficultyLevelMax, difficultyLevelMaxReachable = _a.difficultyLevelMaxReachable, difficultyLevelMaxSelectable = _a.difficultyLevelMaxSelectable, _c = _a.isEnabled, isEnabled = _c === void 0 ? true : _c, onDifficultyClick = _a.onDifficultyClick;
    var difficulty = [];
    var _loop_1 = function (index) {
        var isLocked = index > difficultyLevelMaxSelectable;
        var onClick = isEnabled && !isLocked
            ? function () {
                if (onDifficultyClick) {
                    onDifficultyClick(index);
                }
            }
            : undefined;
        difficulty.push(React.createElement(DifficultyLevelItem, { key: "difficulty-level_" + index, isReachable: index <= difficultyLevelMaxReachable, isSelected: index <= difficultyLevel, isLocked: isLocked, onClick: onClick }));
    };
    for (var index = 1; index <= difficultyLevelMax; index++) {
        _loop_1(index);
    }
    return React.createElement("div", { className: "flex margin--large flex--guts " + className }, difficulty);
});



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/DifficultyLevelSelection.tsx
// module id = 2593
// module chunks = 3